var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":"/start"}},[_c('i',{staticClass:"fas fa-arrow-left pr-2"}),_vm._v(" Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }